module.exports = __webpack_public_path__ + "static/media/logo.7793cbd6.png";